import React, { Component } from 'react';
import ReactMarkdown from 'react-markdown';
import styles from './markdown.module.scss';

const Heading = props => {
  if (props.level === 1) {
    return <h1 className={styles.h1}>{props.children}</h1>;
  }
  if (props.level === 2) {
    return <h2 className={styles.h2}>{props.children}</h2>;
  }
  if (props.level === 3) {
    return <h3 className={styles.h3}>{props.children}</h3>;
  }
  throw Error(`Heading level ${props.level} not handled`);
};
const ListItem = props => {
  return <li className={styles.li}>{props.children}</li>;
};

class Markdown extends Component {
  render() {
    return (
      <ReactMarkdown
        className={this.props.className}
        source={this.props.content}
        renderers={{
          heading: Heading,
          listItem: ListItem,
        }}
      />
    );
  }
}

export default Markdown;



// WEBPACK FOOTER //
// ./src/components/markdown/markdown.js